import { Control, Controller, FieldErrors, UseFormRegister } from "react-hook-form";

import { Input, SelectV2 } from "@/modules/common/components";
import { ADMIN_USER_ROLE_OPTIONS, ADMIN_USER_STATUS_OPTIONS } from "@/modules/common/types/Users.enum";
import { AdminUserFormData } from "../../schemas";

interface AdminUserFormFieldsProps {
  register: UseFormRegister<AdminUserFormData>;
  control: Control<AdminUserFormData>;
  errors: FieldErrors<AdminUserFormData>;
}

const AdminUserFormFields = ({ register, control, errors }: AdminUserFormFieldsProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div>
        <Input label="Nome" markAsRequired {...register("name")} />
        {errors.name && <p className="mt-1 text-xs text-red-500">{errors.name.message}</p>}
      </div>

      <div>
        <Input label="E-mail" markAsRequired maskType="email" {...register("email")} />
        {errors.email && <p className="mt-1 text-xs text-red-500">{errors.email.message}</p>}
      </div>

      <div>
        <Input label="Telefone" maskType="tel" {...register("phoneNumber")} />
        {errors.phoneNumber && <p className="mt-1 text-xs text-red-500">{errors.phoneNumber.message}</p>}
      </div>

      <div>
        <Controller
          name="role"
          control={control}
          render={({ field }) => (
            <SelectV2
              mode="single"
              label="Perfil"
              markAsRequired
              placeholder="Selecione o perfil"
              options={ADMIN_USER_ROLE_OPTIONS}
              value={field.value || undefined}
              onChange={(next) => field.onChange(next ?? "")}
            />
          )}
        />
        {errors.role && <p className="mt-1 text-xs text-red-500">{errors.role.message}</p>}
      </div>

      <div>
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <SelectV2
              mode="single"
              label="Status"
              options={ADMIN_USER_STATUS_OPTIONS}
              value={field.value || undefined}
              onChange={(next) => field.onChange(next ?? "")}
            />
          )}
        />
        {errors.status && <p className="mt-1 text-xs text-red-500">{errors.status.message}</p>}
      </div>
    </div>
  );
};

export default AdminUserFormFields;
